import { render } from "./MdcLinearProgress.vue?vue&type=template&id=5a21b451&scoped=true&lang=pug"
import script from "./MdcLinearProgress.vue?vue&type=script&lang=ts"
export * from "./MdcLinearProgress.vue?vue&type=script&lang=ts"

import "./MdcLinearProgress.vue?vue&type=style&index=0&id=5a21b451&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5a21b451"

export default script